import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import LineChart from "../../../layouts/LineChart";
import { motion } from "framer-motion";
import { floatIn } from "../../../utils/motion";
import KPIIndicator from "../../../layouts/KPIIndicator";
import Gauge from "../../../layouts/Gauge";

const DashboardOccupancy = ({ dataList }) => {
  const building = useSelector((state) => state.building.data);
  const floor = useSelector((state) => state.floor.data);
  const dark = useSelector((state) => state.dark.data);
  const navigate = useNavigate();

  return (
    <>
      {/* Data is still loading  */}
      {dataList === undefined ? (
        <motion.div
          className="h-50 border-main rounded p-3 dashboard-health d-flex flex-column"
          variants={floatIn}
          initial="hidden"
          whileInView="show"
        >
          <div className="d-flex flex-column align-items-start px-2">
            <p className="dashboard-health-title text-main hover-underline m-0">
              <p
                className="d-inline p-0 dashboard-health-title"
                style={{
                  fontFamily: "Roboto",
                  fontSize: "26px",
                  fontWeight: 200,
                  color: "#fffff",
                }}
              >
                Occupancy
              </p>
            </p>
            <p
              className="dashboard-health-lead m-0"
              style={{
                fontFamily: "Roboto",
                fontSize: "18px",
                fontWeight: 300,
                color: "#7695b1",
                fontVariant: "sub",
              }}
            >
              Overall building's occupancy
            </p>
          </div>
          <div className="dashboard-health-body flex-fill mt-3">
            <div className="col text-center justify-content-center align-items-center d-flex h-100">
              <div class="spinner-border text-primary " role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </motion.div>
      ) : dataList?.subscribed && floor ? (
        <motion.div
          className={`h-55  cursor-pointer border-main rounded p-3 dashboard-health d-flex flex-column`}
          variants={floatIn}
          initial="hidden"
          whileInView="show"
          whileHover={{ scale: 0.95 }}
          onClick={() => navigate("/performance")}
        >
          <Link to="/performance">
            <div className="w-100 d-flex justify-content-between align-items-center">
              <div className="d-flex flex-column align-items-start px-2">
                <p className="dashboard-health-title text-main m-0">
                  <p className="d-inline p-0 dashboard-health-title"
                  style={{
                    fontFamily: "Roboto",
                    fontSize: "26px",
                    fontWeight: 200,
                    color: "#fffff",
                  }}
                  
                  >
                    Occupancy
                  </p>
                </p>
                <p
                  className="dashboard-health-lead m-0"
                  style={{
                    fontFamily: "Roboto",
                    fontSize: "18px",
                    fontWeight: 300,
                    color: "#7695b1",
                    fontVariant: "sub",
                  }}
                >
                  Overall building's occupancy
                </p>
              </div>
              <div className="">
                <KPIIndicator
                  title={"Avg. Utilization"}
                  value={dataList?.avgUtilization}
                  dark={dark}
                  threshold={10}
                />
              </div>
            </div>
          </Link>

          {/* Logic 2 - Gauges Space Utilization, Occupancy Utilization and Occupancy Density */}
          <div className="dashboard-health-body flex-fill">
            <div className="row h-20 mt-2 w-100 mx-auto d-flex justify-content-center align-items-center">
              {dataList.gauges?.map((gauge, i) => (
                <div
                  className="col-xs-12 col-md-4 col-lg-4 text-center d-flex align-items-center justify-content-start flex-column"
                  key={i}
                >
                  <Gauge
                    data={gauge}
                    additionalData={dataList?.noOfPeopleByLocation}
                    className="dashboard-health-title"
                    style={{ maxWidth: "100px", width: "80%" }}
                  />
                </div>
              ))}
            </div>
            <div className="h-50 dashboard-health-title">
              <div className="h-100 text-center dashboard-health-title d-flex">
                {dataList.graphs?.map((graph, index) => (
                  <LineChart
                    dataList={graph}
                    dark={dark}
                    aspect={1.6}
                    i={index}
                    key={index}
                  />
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      ) : (
        <motion.div
          className={`h-55 border-main rounded p-3 dashboard-health d-flex flex-column`}
          variants={floatIn}
          initial="hidden"
          whileInView="show"
        >
          <div className="w-100 d-flex justify-content-between align-items-center">
            <div className="d-flex flex-column align-items-start px-2">
              <p className="dashboard-health-title text-main m-0">
                <p
                  className="d-inline p-0 dashboard-health-title"
                  style={{
                    fontFamily: "Roboto",
                    fontSize: "26px",
                    fontWeight: 200,
                    color: "#fffff",
                  }}
                >
                  Occupancy
                </p>
              </p>
              <p
                className="dashboard-health-lead m-0"
                style={{
                  fontFamily: "Roboto",
                  fontSize: "18px",
                  fontWeight: 300,
                  color: "#7695b1",
                  fontVariant: "sub",
                }}
              >
                Overall building's occupancy
              </p>
            </div>
            {dataList.subcribed && (
              <div className="">
                <KPIIndicator
                  title={"Avg. Utilization"}
                  value={dataList?.avgUtilization}
                  dark={dark}
                  threshold={90}
                />
              </div>
            )}
          </div>
          {/* Logic 2 - Gauges Space Utilization, Occupancy Utilization and Occupancy Density Gauges  and charts */}
          <div className="dashboard-health-body flex-fill">
            {dataList.subscribed ? (
              <>
                <div className="row h-20 mt-2 w-100 mx-auto -flex justify-content-center align-items-center">
                  {dataList.subscribed &&
                    dataList.gauges?.map((gauge, i) => (
                      <div
                        className="col-xs-12 col-md-4 col-lg-4 text-center d-flex align-items-center justify-content-start flex-column"
                        key={i}
                      >
                        <Gauge
                          data={gauge}
                          additionalData={dataList?.noOfPeopleByLocation}
                          className="dashboard-health-title"
                          style={{ maxWidth: "100px", width: "80%" }}
                        />
                      </div>
                    ))}
                </div>
                <div className="h-50 dashboard-health-title">
                  <div className="h-100 text-center dashboard-health-title d-flex">
                    {dataList.subscribed &&
                      dataList.graphs.map((graph, index) => (
                        <LineChart
                          dataList={graph}
                          dark={dark}
                          aspect={1.6}
                          i={index}
                          key={index}
                        />
                      ))}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="row mt-2 w-100 h-100 d-flex justify-content-center align-items-center">
                  {dataList.message}
                </div>
              </>
            )}
          </div>
        </motion.div>
      )}
    </>
  );
};

export default DashboardOccupancy;
